module.exports = __webpack_public_path__ + "media/images/geckolyst_logo-765b3f80142e0d558cb25b375c863e3c.svg";